import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-year-picker',
  templateUrl: './year-picker.component.html',
  styleUrls: ['./year-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class YearPickerComponent {
  private dateAdapter = inject(DateAdapter);

  year = input.required<number>();
  yearChange = output<number>();

  startDate = computed(() => new Date(this.year(), 0, 1));

  previousYear = (): void => this.yearChange.emit(this.year() - 1);
  nextYear = (): void => this.yearChange.emit(this.year() + 1);

  onYearSelected(event: Date, picker: MatDatepicker<Date>): void {
    picker.close();
    this.yearChange.emit(this.dateAdapter.getYear(event));
  }
}
